
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anonymous-instagram-story-viewer",
      function () {
        return require("private-next-pages/anonymous-instagram-story-viewer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anonymous-instagram-story-viewer"])
      });
    }
  